import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-492afc99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "caption" }

import { computed } from 'vue'
import { useContentStore } from '@/rd/ContentStore'
import { useContentTagStore } from '@/rd/ContentTagStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentItem',
  props: {
    contentId: {},
    contentTagId: {}
  },
  setup(__props: any) {

const props = __props;



const contentStore = useContentStore()
const contentTagStore = useContentTagStore()

// https://github.com/microsoft/fluentui/blob/master/packages/react-file-type-icons/src/initializeFileTypeIcons.tsx
// NOTE: https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/item-types/48/pdf.svg

const contentRef = computed(() => contentStore.getLoadedContents([props.contentId]).at(0))
const contentTagRef = computed(() => contentTagStore.getLoadedTags([props.contentTagId]).at(0))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (contentRef.value?.isImage)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: contentRef.value?.galleryUrl
        }, null, 8, _hoisted_2))
      : (contentRef.value?.icon)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: contentRef.value.icon,
            class: "file"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, _toDisplayString(contentRef.value?.caption), 1)
  ]))
}
}

})